export enum QuoteItemTypeEnum {
	SERVICE = 'SERVICE',
	PRODUCT = 'PRODUCT',
}
